import { useNavigate } from "react-router-dom";
import { Flex } from "antd";
import LockOutlined from "@ant-design/icons/LockOutlined";
import LogoutOutlined from "@ant-design/icons/LogoutOutlined";
import UserOutlined from "@ant-design/icons/UserOutlined";
import { ItemType } from "antd/lib/menu/interface";

import useAuth from "@hooks/useAuth";

import { Menu, MenuText } from "./styles";

export const UserDropdown = () => {
  const navigate = useNavigate();
  const { name, user, onLogout } = useAuth();

  const resetPassword = () => {
    void navigate("/nova-senha");
  };

  const items: ItemType[] = [
    {
      key: "subMenu",
      label: (
        <Flex align="flex-start" gap={8} style={{ width: "100%" }}>
          <UserOutlined />

          <Flex vertical gap={6} style={{ width: "95%" }}>
            <MenuText strong title={name}>
              {name}
            </MenuText>
            {user?.corbanName && (
              <MenuText title={user.corbanName} style={{ fontSize: 12 }}>
                {user.corbanName}
              </MenuText>
            )}
          </Flex>
        </Flex>
      ),
      popupOffset: [0],
      children: [
        {
          key: "changePassword",
          icon: <LockOutlined />,
          onClick: resetPassword,
          label: "Alterar Senha",
        },
        {
          key: "logout",
          icon: <LogoutOutlined />,
          onClick: () => onLogout(),
          label: "Sair",
        },
      ],
    },
  ];

  return <Menu items={items} mode="horizontal" disabledOverflow />;
};
